/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { updateProfile } from '../../config/updateProfile.config';

import axios from 'axios';
import { Graphql } from '@common/graphql';
import { GET_MY_PROFILE } from '../../api/graphql';
import { vappContainer } from '@/application';
import { apiConfig } from '@/config/apiConfig';
import { toHeaderCase } from 'js-convert-case';
import { featuresSection } from '../../config/featuresSection.config';
import { StorageModule } from '@vlinder-web/storage-module-react';
import { AppNavigatorService } from '@/AppNavigator';

export interface IGetProfileMethods extends IPluginMethodMap {
  getProfile(args: any): Promise<any>;
}

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export class GetProfileService implements IAgentPlugin {
  readonly methods: IGetProfileMethods;

  constructor() {
    this.methods = {
      getProfile: this.getProfile.bind(this),
    };
  }

  async getProfile(args: any) {
    let gql = Graphql.withBaseUrl(apiConfig?.gql?.url);
    const token = loginSrv()?.getToken();
    if (token) {
      gql = gql.withHeaders({
        authentication: token,
      });
    }
    const client = gql.getClient();

    const storageSrv = StorageModule.getInstance();
    const _localData = storageSrv.get('userProfile', 'local');
    const _sessionData = storageSrv.get('userProfile', 'session');
    const userData = _sessionData ?? _localData;

    console.log('data in query', args);
    try {
      if (client) {
        console.log(client);
        const res = await client.query(GET_MY_PROFILE, {}).toPromise();
        console.log('profileress->', res, token);
        if (res?.data?.getMyProfile) {
          storageSrv?.set(
            'myProfile',
            { trn: 'TRY098756', ...res?.data?.getMyProfile },
            'session'
          );
          let _res = res?.data?.getMyProfile;
          return {
            title: `${toHeaderCase(_res?.lastName ?? '')}, ${toHeaderCase(
              _res?.firstName ?? ''
            )}`,
            subtitle: _res?.vuid
              ? `Account ID: ${_res?.vuid}`
              : _res?.occupation,
            heroImage: {
              image: _res?.image ?? 'https://i.ibb.co/k6hxpL1p/image.png',
              // `https://ui-avatars.com/api/?name=${_res.lastName}+${_res?.firstName}&background=0D8ABC&color=fff`,
            },
            listItems: this.getListItems(_res),
            initialData: {
              lastName: _res?.lastName,
              firstName: _res?.firstName,
              image: _res?.image,
              telephone: _res?.primaryContactNo,
              address: _res?.address?.addressLine1,
              city: _res?.address?.city,
              country: _res?.address?.country,
              occupation: _res?.occupation,
            },
            statusComp: this.statusComp(_res?.accountStatus),

            buttons:
              _res?.accountStatus === 'ACTIVE' ||
              _res?.accountStatus === 'TEMPORARILY_UNAVAILABLE'
                ? featuresSection?.buttons?.filter((item) => {
                    if (_res?.accountStatus === 'ACTIVE') {
                      return item?.key === 'inactive';
                    }
                    if (_res?.accountStatus === 'TEMPORARILY_UNAVAILABLE') {
                      return item?.key === 'active';
                    }
                    return true;
                  })
                : [],
            organizationProfile: {
              title: _res?.org?.name,
              subtitle: _res?.org?.description,
              heroImage: {
                image:
                  _res?.org?.logo ??
                  `https://ui-avatars.com/api/?name=${_res.org?.name}&background=0D8ABC&color=fff`,
              },
              listItems: this.getOrgListItems(_res?.org),
              // buttons: featureProfileConfig?.buttons,
              formDefaultData: {
                name: _res?.org?.name,
                description: _res?.org?.description,
                image: _res?.org?.logo,
                address: _res?.org?.address?.addressLine1,
                country: _res?.org?.address?.country,
                city: _res?.org?.address?.city,
                telephone: _res?.org?.primaryContactNo,
                website: _res?.org?.website,
              },
            },
          };
        }

        throw res?.data?.errors?.[0];
      }
    } catch (err: any) {
      throw err;
    }
  }

  private statusComp = (status: any) => {
    console.log('status->', status);
    if (status === 'ACTIVE') {
      return {
        title: `Active`,
        statusType: 'success',
      };
    }
    if (status === 'TEMPORARILY_UNAVAILABLE') {
      return {
        title: `Inactive`,
        statusType: 'warning',
      };
    }
    if (status === 'SUSPENDED') {
      return {
        title: `Suspended`,
        statusType: 'danger',
      };
    }
    if (status === 'DEACTIVATED') {
      return {
        title: `Deactivated`,
        statusType: 'danger',
      };
    }
    if (status === 'INVITED') {
      return {
        title: `Invited`,
        statusType: 'warning',
      };
    }
  };

  private getOrgListItems(res: any) {
    let _temp = [];
    _temp = featuresSection?.orgListItems?.map((item) => {
      if (item?.title === 'Company Registration Number') {
        return {
          ...item,
          subTitle: res?.cNumber ? `${res?.cNumber}` : '-',
        };
      }

      if (item?.title === 'Address') {
        return {
          ...item,
          subTitle: res?.address ? `${res?.address}` : '-',
        };
      }
      if (item?.title === 'City/Town') {
        return {
          ...item,
          subTitle: res?.city ?? '-',
        };
      }

      if (item?.title === 'Country') {
        return {
          ...item,
          subTitle: '-',
          flag: res?.country,
        };
      }
      if (item?.title === 'Email') {
        return {
          ...item,
          subTitle: res?.email ?? '-',
        };
      }
      if (item?.title === 'Phone Number') {
        return {
          ...item,
          subTitle: res?.telephone ?? '-',
        };
      }
      if (item?.title === 'Website') {
        return {
          ...item,
          subTitle: res?.website ?? '-',
        };
      }
    });
    return _temp;
  }

  private getListItems(res: any) {
    let _temp: any[] = [];
    featuresSection?.listItems?.map((item) => {
      if (item?.title === 'Last Name') {
        _temp.push({
          ...item,
          subTitle: res?.lastName ? `${toHeaderCase(res?.lastName)}` : '-',
        });
      }
      if (item?.title === 'First Name') {
        _temp.push({
          ...item,
          subTitle: res?.firstName ? `${toHeaderCase(res?.firstName)}` : '-',
        });
      }
      if (item?.title === 'Middle Name' && res?.middleName) {
        _temp.push({
          ...item,
          subTitle: res?.middleName ? `${toHeaderCase(res?.middleName)}` : '-',
        });
      }

      if (item?.title === 'Role') {
        _temp.push({
          ...item,
          subTitle: res?.role?.[0]?.name
            ? `${toHeaderCase(res?.role?.[0]?.name)}`
            : '-',
        });
      }
      if (item?.title === 'TRN') {
        _temp.push({
          ...item,
          subTitle: res?.trn ? `${toHeaderCase(res?.trn)}` : null,
        });
      }
      if (item?.title === 'Nationality' && res?.nationality) {
        _temp.push({
          ...item,
          subTitle: res?.nationality
            ? `${toHeaderCase(res?.nationality)}`
            : '-',
        });
      }
      if (item?.title === 'Telephone') {
        console.log('phnooo', toHeaderCase(res?.primaryContactNo));
        _temp.push({
          ...item,
          subTitle: res?.primaryContactNo ? res?.primaryContactNo : '-',
        });
      }
      if (item?.title === 'Email') {
        _temp.push({
          ...item,
          subTitle: res?.email ? res?.email : '-',
        });
      }
    });
    return _temp;
  }

  private format = (_res: any) => {
    return {
      title: `${toHeaderCase(_res?.firstName ?? '')} ${toHeaderCase(
        _res?.lastName ?? ''
      )}`,
      subtitle: _res?.vuid ? `Account ID: ${_res?.vuid}` : _res?.occupation,
      heroImage: {
        image:
          _res?.image ??
          `https://ui-avatars.com/api/?name=${_res.firstName}+${_res?.lastName}&background=0D8ABC&color=fff`,
      },
      listItems: this.getListItems(_res),
      initialData: {
        lastName: _res?.lastName,
        firstName: _res?.firstName,

        image: _res?.image,
        telephone: _res?.primaryContactNo,
        address: _res?.address?.addressLine1,
        city: _res?.address?.city,
        country: _res?.address?.country,
        occupation: _res?.occupation,
      },
      // statusComp: {
      //   title: `Review Pending`,
      //   statusType: 'warning',
      // },
      buttons: featuresSection?.buttons,
    };
  };
}
